<template>
  <div class="content">
    <base-header class="pb-6">
      <div class="row align-items-center py-4">
        <div class="col-lg-6 col-7">
          <h6 class="h2 text-white d-inline-block mb-0">
            {{ $t("wms.menu.available_product") }}
          </h6>
          <nav aria-label="breadcrumb" class="d-none d-md-inline-block ml-md-4">
            <route-bread-crumb></route-bread-crumb>
          </nav>
        </div>

        <div class="col-lg-6 col-5 text-right">
          <base-button size="md" type="neutral" @click="exportToExcel()" :disabled="loading || tableData.length === 0">
            <i class="fa fa-download"></i> {{ $t("export") }}
          </base-button>
          <base-button size="md" type="neutral" @click="loadData()" :loading="loading">
            <i class="fa fa-sync"></i> {{ $t("refresh") }}
          </base-button>
        </div>
      </div>
    </base-header>
    <div class="container-fluid mt--6">
      <div>
        <card
          class="no-border-card"
          body-classes="px-0 pb-1"
          footer-classes="pb-2"
        >
          <template slot="header">
            <div class="row">
              <base-input
                v-model="searchQuery"
                prepend-icon="fas fa-search"
                :placeholder="$t('search')"
              >
              </base-input>
            </div>
          </template>
          <div>
            <el-table
              :data="queriedData"
              row-key="ProductID"
              header-row-class-name="thead-light"
              v-loading="loading"
              @sort-change="sortChange"
            >
              <el-table-column width="120">
                <div slot-scope="{ row }" class="d-flex">
                  <img :src="GetProductUrl(row.Image)" height="80px" v-if="row.Image && (row.Image.includes('.png') || row.Image.includes('.jpg') || row.Image.includes('jpeg'))"/>
                </div>
              </el-table-column>

              <el-table-column :label="$t('wms.product_name')" min-width="150" sortable prop="ProductName">
                <div slot-scope="{ row }">
                  {{ row.ProductName }}
                </div>
              </el-table-column>

              <el-table-column :label="$t('wms.stock')" min-width="80" sortable prop="Stock">
                <div slot-scope="{ row }">
                  {{ row.Stock }}
                </div>
              </el-table-column>

              <el-table-column :label="$t('wms.packing')" min-width="80" sortable prop="Packing">
                <div slot-scope="{ row }">
                  {{ row.Packing }}
                </div>
              </el-table-column>

              <el-table-column :label="$t('wms.balance') + ' (100%)'" min-width="100" sortable prop="Balance">
                <div slot-scope="{ row }">
                  {{ row.Balance }}
                </div>
              </el-table-column>
            </el-table>
          </div>
          <div
            slot="footer"
            class="col-12 d-flex justify-content-center justify-content-sm-between flex-wrap"
            v-if="queriedData.length != 0"
          >
            <div class="">
              <p class="card-category">
                {{ $t("data") }} {{ from + 1 }} {{ $t("to") }} {{ to }}
                {{ $t("of") }}
                {{ total }}
              </p>
            </div>
            <base-pagination
              class="pagination-no-border"
              v-model="pagination.currentPage"
              :per-page="pagination.perPage"
              :total="total"
            >
            </base-pagination>
          </div>
        </card>
      </div>
    </div>
  </div>
</template>
<script>
import { Table, TableColumn } from "element-ui";
import RouteBreadCrumb from "@/components/Breadcrumb/RouteBreadcrumb";
import { BasePagination } from "@/components";
import clientPaginationMixin from "./PaginatedTables/clientPaginationMixin";
import wmsProductRefetchOnActivate from "@/mixins/wmsProductRefetchOnActivate";
import { filterRowsByActiveProducts } from "@/utils/wmsProductActive";
import { mapActions } from "vuex";
import * as XLSX from "xlsx";

export default {
  mixins: [clientPaginationMixin, wmsProductRefetchOnActivate],
  components: {
    BasePagination,
    RouteBreadCrumb,
    [Table.name]: Table,
    [TableColumn.name]: TableColumn,
  },
  data() {
    return {
      propsToSearch: ["ProductName"],
      tableData: [],
      loading: false,
    };
  },
  mounted() {
    this.loadData();
  },
  methods: {
    ...mapActions({
      calculateStock: "Product/calculateStock",
      listProduct: "WmsProduct/listData",
    }),
    async loadData() {
      this.loading = true;
      try {
        // owner 2026-10-11: only WMS products that are enabled (is_active) —
        // /products/calculate returns every product, so drop rows whose
        // ProductID is not in the active list (list empty / failed = no filter)
        const [resp, activeProducts] = await Promise.all([this.calculateStock(), this.listProduct()]);
        this.tableData = filterRowsByActiveProducts(resp.data.Datum.wms_stock || [], activeProducts);
      } catch (error) {
        console.log(error);
        this.tableData = [];
      } finally {
        this.loading = false;
      }
    },
    // kept-alive tab: a product enabled/disabled elsewhere shows up on return
    refetchWmsProducts() {
      return this.loadData();
    },
    GetProductUrl(filename) {
      if (!filename) return "";
      return process.env.VUE_APP_API_BASE_URL + "/files/wms_products/" + filename;
    },
    exportToExcel() {
      // Use searchedData if searching, otherwise use tableData (both are already sorted)
      const dataToExport = this.searchedData.length > 0 ? this.searchedData : this.tableData;

      // Map data to export format
      const exportData = dataToExport.map((row, index) => ({
        "No.": index + 1,
        [this.$t('wms.product_name')]: row.ProductName,
        [this.$t('wms.stock')]: row.Stock,
        [this.$t('wms.packing')]: row.Packing,
        [this.$t('wms.balance') + ' (100%)']: row.Balance,
      }));

      // Create worksheet and workbook
      const ws = XLSX.utils.json_to_sheet(exportData);
      const wb = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(wb, ws, "Available Stock");

      // Generate filename with date
      const date = new Date().toISOString().slice(0, 10);
      const filename = `available_stock_${date}.xlsx`;

      // Save file
      XLSX.writeFile(wb, filename);
    },
  },
};
</script>
<style>
.no-border-card .card-footer {
  border-top: 0;
}
</style>
